import {Component, OnInit, Input, AfterContentChecked, ChangeDetectorRef, forwardRef, OnChanges, SimpleChanges} from '@angular/core';
import { FormBuilder, FormArray, FormGroup, NG_VALUE_ACCESSOR, ControlValueAccessor, Validators, NG_VALIDATORS } from '@angular/forms';
import { AbwDatasourceColumn, TYPE_DEFAULT_VALUE, Model_WorkflowComponent, FONCTION_WORKFLOW_COMPONENT_OPTIONS, Model_VariableEnvironnement, EXPRESSION_FIELD_SCOPE, AbwDatasourceParameter } from 'src/app/app.models';
import { MatTableDataSource } from '@angular/material/table';

@Component({
    selector: 'abw-datasource-parameters-columns',
    templateUrl: './datasource-parameters-columns.component.html',
    styleUrls: ['./datasource-parameters-columns.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DatasourceParametersColumnsComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => DatasourceParametersColumnsComponent),
            multi: true
        }
    ],
})
export class DatasourceParametersColumnsComponent implements OnInit, AfterContentChecked, ControlValueAccessor {
    @Input() datasourceColumns: AbwDatasourceColumn[] = [];
    @Input() workflowComponents: Model_WorkflowComponent[] = [];
    @Input() gridComponents?: Model_WorkflowComponent[];
    @Input() variables: Model_VariableEnvironnement[] = [];
    @Input() value: any;
    displayedColumns = ['NAME', 'TYPE_DEFAULT_VALUE', 'DEFAULT_VALUE'];
    dataSource = new MatTableDataSource<FormGroup>();
    form = this._formBuilder.group({
        formArray: this._formBuilder.array([])
    });
    TYPE_DEFAULT_VALUE = TYPE_DEFAULT_VALUE;
    FONCTION_WORKFLOW_COMPONENT_OPTIONS = FONCTION_WORKFLOW_COMPONENT_OPTIONS;

    constructor(
        private _formBuilder: FormBuilder,
        private _cdf: ChangeDetectorRef
    ) {
    }

    ngOnInit() {
    }

    ngAfterContentChecked() {
        this._cdf.detectChanges();
    }

    propagateChange = (_: any) => {};
    registerOnChange(fn) { this.propagateChange = fn; }
    registerOnTouched() {}
    writeValue(value: AbwDatasourceParameter[]) {
        if (!!value) {
            const rows = value.map(row => this._formBuilder.group({
                NAME: [row.NAME],
                TYPE_DEFAULT_VALUE: [row.TYPE_DEFAULT_VALUE || TYPE_DEFAULT_VALUE.CONSTANT],
                DEFAULT_VALUE: [row.DEFAULT_VALUE]
            }));
            this.value = rows; 
            this.dataSource.data = rows;
        }
    }
    validate(control: any): { [key: string]: any } | null {
        const isValid = (this.dataSource.data as FormGroup[]).map(f => f.valid).reduce((current, next) => current && next, true);
        return !isValid ? { required: true } : null;
    }

	onValueChanged() {
        const rows = this.dataSource.data;
        this.value = rows.map(formGroup => formGroup.value);
	  	this.propagateChange(this.value);
        this._cdf.detectChanges();
	}
}